import {useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {MergeDlg} from '@/pages/MainPage/frames/PrjBranchMerge/CreateIncMerge.jsx'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonMerge(props) {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode, pblType, prjId, sVer: srcSVer} = map.data

    if (! (
        'SA_MAP' === mapTypeCode &&
        'INCREMENT' === pblType
    )) {
        return null
    }

    const onClick = () => openModal(
        <MergeDlg
            prjId={prjId}
            srcSVer={srcSVer}
        />
    )

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            合并分支
        </MenuButton>
    )
}
